import { render, staticRenderFns } from "./TrademarkSearchHistoryList.vue?vue&type=template&id=5c2a9d0d&"
import script from "./TrademarkSearchHistoryList.vue?vue&type=script&lang=js&"
export * from "./TrademarkSearchHistoryList.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkSearchHistoryList.vue?vue&type=style&index=0&id=5c2a9d0d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports